<template>
  <div class="admin-video-wrapper">
    <video
      ref="videoPlayer"
      class="video-js vjs-big-play-centered"
      preload="auto"
      controls="controls"
    >
      <source :src="feed.craw_uri" type="video/mp4" />
    </video>
  </div>
</template>
<script>
import "video.js/dist/video-js.css";
import videojs from "video.js";
import { videoChinese } from "../../../utils/common";
export default {
  name: "admin-video-element",
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      player: null,
      options: {
        language: "zh-CN",
      },
    };
  },
  beforeMount() {
    videojs.addLanguage("zh-CN", videoChinese);
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {}
    );
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style scoped>
.admin-video-wrapper {
  width: 551px;
  height: 310px;
  margin: 10px 0;
}

.admin-video-wrapper .video-js {
  width: 100%;
  height: 100%;
}
</style>